import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccessTokenService } from '../services/authentication/access-token.service';

const SKIP_HEADER = 'Skip-Request';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // Skip requests that explicitly opt-out (e.g. the authentication call itself)
  if (req.headers.has(SKIP_HEADER)) {
    const cleanReq = req.clone({ headers: req.headers.delete(SKIP_HEADER) });
    return next(cleanReq);
  }

  const accessToken = inject(AccessTokenService);
  const token = accessToken.getToken();

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: { Authorization: token },
  });

  return next(authReq);
};
